import React from 'react';
import css from '@/css/module/billing.css';
import flex from '@/css/module/flex.css';
import { TrevorIcon } from '@trevor/ui-components';
import { AddToSubscription } from '@/features/credits/components/AddToSubscription';
import styled from 'styled-components';

export const ADD_TO_EXISTING = 'addToExisting';
export const START_NEW = 'startNew';

export const SubscriptionViewSelect: React.FC<{
  subscriptionView: string;
  onSelect: F<string>;
  onActivation: F0;
}> = ({ subscriptionView, onSelect, onActivation }) => {
  const changeView = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSelect(e.target.value);
  };

  return (
    <Container>
      <div className={`${flex.row} ${flex.alignItemsCenter}`}>
        <div className={`${css.billingIcon} ${flex.alignItemsCenter}`}>
          <TrevorIcon name="pen" />
        </div>
        <div className={flex.alignItemsCenter}>
          <b>Subscription</b>
        </div>
      </div>
      <LabelWrapper>
        <Label>
          <input
            type="radio"
            value={ADD_TO_EXISTING}
            checked={subscriptionView === ADD_TO_EXISTING}
            name="subscriptionView"
            onChange={changeView}
          />
          Add to existing subscription
        </Label>
        {subscriptionView === ADD_TO_EXISTING && (
          <AddToSubscription onSuccess={onActivation} />
        )}
        <Label>
          <input
            type="radio"
            value={START_NEW}
            checked={subscriptionView === START_NEW}
            name="subscriptionView"
            onChange={changeView}
          />
          Start new subscription
        </Label>
      </LabelWrapper>
    </Container>
  );
};

const Label = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  margin-bottom: 15px;
  display: flex;
  gap: 10px;

  input {
    margin: 0;
  }
`;

const LabelWrapper = styled.div`
  margin-left: 40px;
  margin-top: 15px;
`;

const Container = styled.div`
  padding: 0 10px;
`;
